module.exports = __webpack_public_path__ + "img/level01.2720956d.png";